import React from "react";
import {Link} from "react-router-dom";
import Logo from "../assets/fillopsLogo.png";

export default function PublicEditorialHeader({showNavigation = true}) {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white">
      <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-6">
        <Link to="/blog" aria-label="Fillop Blog" className="flex items-center gap-2.5 no-underline">
          <img src={Logo} alt="" className="h-8 w-8 object-contain" />
          <span className="text-xl font-extrabold tracking-tight text-blue-900">Fillop <span className="text-orange-500">Blog</span></span>
        </Link>
        {showNavigation && <nav className="flex items-center gap-2 md:gap-4" aria-label="Main navigation">
          <Link to="/" className="border border-transparent px-3 py-2 text-sm font-semibold text-slate-500 no-underline transition hover:border-slate-200 hover:bg-slate-100 hover:text-slate-900">Explore</Link>
          <a href="https://filloptech.com/" className="hidden border border-transparent px-3 py-2 text-sm font-semibold text-slate-500 no-underline transition hover:border-slate-200 hover:bg-slate-100 hover:text-slate-900 sm:block">Professional Courses</a>
        </nav>}
      </div>
    </header>
  );
}
